import Vue from 'vue'
import Vuex from 'vuex'
import admin from './modules/admin'
import client from './modules/client'
import host from './modules/host'


Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    admin,
    client,
    host
  }
})
